import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { PropertyComponent } from './components/property/property.component';
import { NewPasswordActivationComponent } from './components/new-password-activation/new-password-activation.component';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { RegisterComponent } from './components/register/register.component';
import { RegisterActivationComponent } from './components/register-activation/register-activation.component';

const routes: Routes = [
  {
    path: "",
    component: LoginComponent
  },
  {
    path: "properties",
    component: PropertyComponent
  },
  {
    path: "forget-password",
    component: ForgetPasswordComponent
  },
  {
    path: "new-password-activation",
    component: NewPasswordActivationComponent,
  },
  {
    path: "register",
    component: RegisterComponent,
  },
  {
    path: "register-activation",
    component: RegisterActivationComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
